module.exports = __webpack_public_path__ + "./images/67f2d8f2fc6d7a1e2023fc77fb835c6f.webp";